import React, {Fragment} from "react";
import CustomFieldDisplay from "../../../components/CustomFieldDisplay";
import ListView from "../../../components/ContentDisplay/ListView";
import {OBJECT_TYPES} from "../../../constants/objectTypes";
import AddCustomer from "../addCustomer";
import CustomerCard from "./customerCard";
import {useCustomerSearchOptions} from "./useCustomerSearchOptions";
import {LIST_HEADERS, ACTIONS_LIST, PERMS_FOR_ACTIONS} from "./customerTable.constants";
import {useCustomerTableActions} from "./useCustomerTableActions";
import {useCustomerTableData} from "./useCustomerTableData";
import "./customersTable.scss";

const CustomersTable = ({defaultRoute, openAddCustomer}) => {
  const {searchOptions} = useCustomerSearchOptions();
  const {
    customersList,
    CustomerTotalCount,
    handleSearch,
    paginationConfig,
    switchCurrentCustomer,
  } = useCustomerTableData(openAddCustomer);
  const {
    closeCustomFieldModal,
    closeEditModal,
    editModalStatus,
    isCustomFieldModalOpen,
    handleActionSelection,
    selectedRow,
  } = useCustomerTableActions();

  return (
    <Fragment>
      {isCustomFieldModalOpen && (
        <CustomFieldDisplay
          objectId={selectedRow.id}
          objectType={OBJECT_TYPES.Customer}
          onToggle={closeCustomFieldModal}
          open={isCustomFieldModalOpen}
        />
      )}
      {editModalStatus && (
        <AddCustomer
          data={selectedRow}
          defaultRoute={defaultRoute}
          onCancel={closeEditModal}
          open={editModalStatus}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={customersList}
          listHeaders={LIST_HEADERS}
          booleanAsToggle
          onClickToggle={(data) => switchCurrentCustomer(data)}
          onSelectAction={handleActionSelection}
          withActions
          totalCount={CustomerTotalCount}
          withPagination={paginationConfig}
          actionsList={ACTIONS_LIST}
          permsForActions={PERMS_FOR_ACTIONS}
          toggleTestId={"switch_customer"}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Customers"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={CustomerCard}
        />
      </div>
    </Fragment>
  );
};

export default CustomersTable;
